// IBM Plex Sans, self-hosted. Three weights carry the whole hierarchy:
// 300 for display sizes (42px+), 400 for body, 600 for emphasis.
require('@fontsource/ibm-plex-sans/300.css')
require('@fontsource/ibm-plex-sans/400.css')
require('@fontsource/ibm-plex-sans/600.css')
